// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"
import store from "./store"
import globalVar from '@/util/globalVar'
Vue.prototype.globalVar = globalVar
import globalmenu from '@/util/globalmenu'
Vue.prototype.globalmenu = globalmenu
// video
import VueVideoPlayer from "vue-video-player"
import "video.js/dist/video-js.css"
import "vue-video-player/src/custom-theme.css"
Vue.use(VueVideoPlayer)

import "viewerjs/dist/viewer.css"
import Viewer from "v-viewer"
Vue.use(Viewer)

let FastClick = require("../static/js/fastclick")
FastClick.attach(document.body);

import * as uiv from 'uiv'
Vue.use(uiv);


import '@/assets/icon/iconfont.css'




import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false




router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  console.log(to)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js